import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as alertifyjs from 'alertifyjs';
import { RbacVigilanteService } from 'src/app/services/rbac/rbac-vigilante.service';
import { RbacAdminService } from 'src/app/services/rbac-admin/rbac-admin.service';
import { IsProfileGuard } from 'src/app/guards/isProfile.guard';
import {
  ACCIONES_ESTANDAR, MODULO_NUEVO, RutaConsola, TEXTO_SIN_ROLES, alternarRol, aplanarRutas, aplicarMarca, armarCuerpo,
  ayudaDeParametro, buscarCasillas, buscarFilaDePantalla, nombreMatrizDeRuta, codigosDelMapaDeRuta, buscarRutas, casillasDeMatriz, conFilaExistente, cuerpoModulo,
  mensajeErrorModulo, problemaDeModulo, sinFilaExistente, textoFilaExistente, textoFilasElegida,
  codigosRepetidos, contarMarcas, contarPermisos, crearEstado, etiquetaMetodo, filasProtecciones, filtrarRutasServidor,
  formularioDeToque, conAlcance, nombresDePermisos, textoYaTiene, grupoDeFila, hayFiltroProtecciones, llenarRuta, marcasDeRuta, pasosDeAgregar, textoContadorMarcas, marcasParaIframe, mensajeAsignados,
  mensajeErrorProteccion, mensajeRepetidos, metodoSugerido, moduloDeRuta, nombreDeRuta, parametrosFaltantes,
  permisosDeRuta, problemaDeMarca, problemasDeEstado, quitarMarca, repartirRoles, resumenProtecciones,
  resumenRolesMarcados, rolesAAsignar, rolesPreseleccionados, rutaAbiertaCoincide, textoEncender, textoRutaDesviada,
  textoYaTienenTodo, detalleDeMarca, llamadasDelMensaje, notaCoincidencias, queTocaste, dondeSeAgrega, resumenAgregar,
  resumenQuienVera, sugerenciasServidor, textoLlanoMetodo, ultimoTramo
} from './agregar-permisos.logica';

/**
 * Pestaña «Agregar permisos» de Roles y Permisos.
 *
 * Se escribe la ruta de una pantalla, se abre real dentro de un iframe en modo marcador (la propia consola, sin que los
 * clics ejecuten nada), se toca lo que se quiere proteger y todo entra a la Matriz de Permisos con un solo guardado.
 * El lado de adentro del iframe (marcador, huella, vigilante) es de la pantalla; aquí se habla con él por postMessage
 * del mismo origen: `rbac-marcador:listo | toque | llamadas` de ida y `rbac-marcador:marcas | subir | limpiar | modo` de vuelta.
 * La lógica que no necesita Angular está en agregar-permisos.logica.ts (con prueba en node:test).
 */
@Component({
  selector: 'app-agregar-permisos',
  templateUrl: './agregar-permisos.component.html'
})
export class AgregarPermisosComponent implements OnInit, OnDestroy {

  /** Se guardó: el padre recarga la matriz. Trae { creados, marcas, protecciones }. */
  @Output() guardado = new EventEmitter<any>();
  /** «Ver en la matriz»: el padre cambia a la pestaña de la matriz. */
  @Output() verEnMatriz = new EventEmitter<void>();

  @ViewChild('marcador') marcador?: ElementRef<HTMLIFrameElement>;
  @ViewChild('formulario') formulario?: ElementRef<HTMLElement>;

  // ── Datos del API ──
  cargando = true;
  errorCarga = '';
  pantallas: any[] = [];
  rutas: RutaConsola[] = [];
  rutasServidor: any[] = [];
  cargandoServidor = false;
  errorServidor = false;
  private servidorPedido = false;

  // ── Paso 1: la ruta ──
  consulta = '';
  sugerencias: RutaConsola[] = [];
  rutaElegida: RutaConsola | null = null;
  valores: { [parametro: string]: string } = {};
  pidiendoValores = false;

  // ── Paso 2: la pantalla en modo marcador ──
  rutaAbierta = '';
  /** Ruta en la que quedó la pantalla cuando no es la pedida (redirigió): bloquea marcar y guardar hasta cambiar de pantalla. */
  rutaDesviada = '';
  urlMarcador: SafeResourceUrl | null = null;
  estado: any = null;
  marcasGuardadas: any[] = [];
  /** La fila de la matriz que ya es esta pantalla (por sus permisos o por una marca), o `null`. */
  filaDetectada: any = null;
  /** La persona pidió «Crear un submódulo nuevo en su lugar»: no se vuelve a proponer la fila existente. */
  quiereSubmoduloNuevo = false;
  readonly moduloNuevo = MODULO_NUEVO;

  // ── Módulo nuevo ──
  creandoModulo = false;
  nuevoModulo = { nombre: '', despuesDe: '' };
  errorModulo = '';
  guardandoModulo = false;

  // ── Permiso que ya existe (buscador Módulo › Fila › Casilla) ──
  busquedaPermiso = '';
  resultadosPermiso: any[] = [];
  totalPermiso = 0;

  // ── Paso 3: el formulario de lo tocado ──
  form: any = null;
  errorForm = '';
  busquedaServidor = '';
  resultadosServidor: any[] = [];
  totalServidor = 0;
  readonly accionesEstandar = ACCIONES_ESTANDAR;
  /** «Elegir otra»: abre el buscador aunque ya haya una opción elegida. */
  buscandoOtraOpcion = false;
  /** El formulario de lo tocado antes de «¿Querías marcar toda esa parte?»: «Es solo un botón» lo recupera. */
  private formAntesDeAgrandar: any = null;
  /** La próxima selección que avise la pantalla (la del contenedor) entra como sección. */
  private querraSeccion = false;

  // ── Opciones del equipo técnico: llamadas que la pantalla hizo al cargarse (rbac-marcador:llamadas) ──
  llamadasPantalla: { metodo: string; url: string }[] = [];
  usadasServidor: any[] = [];
  parecidasServidor: any[] = [];
  buscarEnTodas = false;

  // ── Paso 4: guardar ──
  /** Permisos que hoy exige la pantalla elegida (su `data.permissions` en el router); vacío = no exige ninguno. */
  permisosActuales: string[] = [];
  /** Roles activos con `ven` / `yaTieneTodo`, según GET /roles-que-ven. */
  roles: any[] = [];
  cargandoRoles = false;
  errorRoles = '';
  /** «Dar estos permisos a los roles que hoy ya ven esta pantalla»: marcada por defecto. */
  darARoles = true;
  /** Códigos de los roles con la casilla marcada. */
  rolesElegidos: string[] = [];
  /** Roles que no la ven hoy y se agregaron a mano con «Agregar otro rol». */
  rolesExtra: string[] = [];
  bloqueRoles: { lista: any[]; yaTienenTodo: any[]; otros: any[] } = { lista: [], yaTienenTodo: [], otros: [] };
  /** Se descartan las respuestas de un pedido viejo si se cambió de pantalla mientras llegaba. */
  private pedidoRoles = 0;
  readonly textoSinRoles = TEXTO_SIN_ROLES;
  guardando = false;
  errorGuardar = '';
  resultado: any = null;

  // ── Lo que también cuida el servidor (encender y apagar las protecciones) ──
  protecciones: any[] = [];
  proteccionesVisibles: any[] = [];
  cargandoProtecciones = false;
  errorProtecciones = '';
  errorCambio = '';
  busquedaProtecciones = '';
  /** Fila que espera la confirmación de «Encender» (se muestra dentro de la propia fila). */
  proteccionPorEncender: any = null;
  /** Id de la protección que se está cambiando en este momento (bloquea los demás interruptores). */
  cambiandoProteccion = '';

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private rbacService: RbacAdminService,
    private vigilante: RbacVigilanteService
  ) { }

  ngOnInit(): void {
    this.rutas = aplanarRutas(this.router.config);
    this.cargarPantallas();
    this.cargarProtecciones();
  }

  ngOnDestroy(): void { this.ponerBloqueoDeScroll(false); }

  // ══════════════════════════════════════════
  //  PANTALLA COMPLETA
  // ══════════════════════════════════════════

  /** La pantalla marcada ocupa toda la ventana (capa fija). Es lo que se abre por omisión al elegir la ruta. */
  pantallaCompleta = false;

  entrarPantallaCompleta() {
    if (!this.hayPantalla) return;
    this.pantallaCompleta = true;
    this.ponerBloqueoDeScroll(true);
  }

  salirPantallaCompleta() {
    this.pantallaCompleta = false;
    this.ponerBloqueoDeScroll(false);
  }

  /** Con la capa fija no debe moverse la página de atrás. */
  private ponerBloqueoDeScroll(bloquear: boolean) {
    document.documentElement.classList.toggle('rbac-agregar-completa', bloquear);
  }

  /** Esc sale de pantalla completa (si el foco está dentro del iframe, la propia pantalla avisa con rbac-marcador:salir). */
  @HostListener('document:keydown.escape')
  alPulsarEsc() { if (this.pantallaCompleta) this.salirPantallaCompleta(); }

  get pasosVista() { return pasosDeAgregar(this.hayPantalla, this.estado ? contarMarcas(this.estado) : 0, !!this.resultado); }

  get textoContador(): string { return textoContadorMarcas(this.estado ? contarMarcas(this.estado) : 0); }

  async cargarPantallas() {
    this.cargando = true;
    this.errorCarga = '';
    try {
      const resp = await this.rbacService.getPantallas();
      this.pantallas = resp?.data || [];
      this.nombresMatriz.clear();
    } catch (error: any) {
      console.error('[Agregar permisos] No se pudieron cargar los módulos:', error);
      this.errorCarga = error?.error?.msg || 'No se pudo cargar la lista de módulos de la matriz.';
    }
    this.cargando = false;
    // Los nombres visibles de los permisos salen de estas filas.
    this.filtrarProtecciones();
  }

  // ══════════════════════════════════════════
  //  PASO 1 · LA RUTA
  // ══════════════════════════════════════════

  /** Nombre de la matriz para una opción del buscador («Perfil del Contacto · Contactos»); '' si no se sabe. */
  private nombresMatriz = new Map<string, string>();
  nombreMatrizDe(r: RutaConsola): string {
    if (!this.pantallas.length) return '';
    let v = this.nombresMatriz.get(r.ruta);
    if (v === undefined) {
      v = nombreMatrizDeRuta(r.ruta, permisosDeRuta(this.router.config, r.ruta), IsProfileGuard.URL_MODULE_MAP, this.pantallas);
      this.nombresMatriz.set(r.ruta, v);
    }
    return v;
  }

  ayudaParametro(p: string): string { return ayudaDeParametro(p); }

  get hayPantalla(): boolean { return !!this.rutaAbierta; }

  alEscribirRuta() {
    this.sugerencias = buscarRutas(this.rutas, this.consulta);
    // Si había una pedida de valores a medias y se escribe otra cosa, se descarta.
    if (this.pidiendoValores) { this.pidiendoValores = false; this.rutaElegida = null; }
  }

  elegirRuta(r: RutaConsola) {
    this.rutaElegida = r;
    this.consulta = r.ruta;
    this.sugerencias = [];
    this.valores = {};
    this.cargarRoles(r.ruta);
    if (r.parametros.length) {
      this.pidiendoValores = true;
    } else {
      this.abrirPantalla();
    }
  }

  get parametrosPendientes(): string[] {
    return this.rutaElegida ? parametrosFaltantes(this.rutaElegida.ruta, this.valores) : [];
  }

  abrirPantalla() {
    const r = this.rutaElegida;
    if (!r || parametrosFaltantes(r.ruta, this.valores).length) return;
    this.pidiendoValores = false;
    this.rutaAbierta = llenarRuta(r.ruta, this.valores);
    this.rutaDesviada = '';
    // Mismo origen: la propia consola dentro del iframe. El nombre del iframe es lo que la activa en modo marcador.
    this.urlMarcador = this.sanitizer.bypassSecurityTrustResourceUrl(window.location.origin + this.rutaAbierta);
    this.estado = crearEstado(r.ruta, nombreDeRuta(r.ruta), moduloDeRuta(r.ruta, this.pantallas));
    this.filaDetectada = null;
    this.quiereSubmoduloNuevo = false;
    this.creandoModulo = false;
    this.errorModulo = '';
    this.detectarFila();
    this.llamadasPantalla = [];
    this.reiniciarFormulario();
    this.cargarRutasServidor();
    this.form = null;
    this.errorForm = '';
    this.errorGuardar = '';
    this.resultado = null;
    this.marcasGuardadas = [];
    this.cargarMarcasGuardadas();
    this.entrarPantallaCompleta();
  }

  /** «Cambiar de pantalla»: pide confirmación si ya hay cosas marcadas sin guardar. */
  cambiarPantalla() {
    if (this.estado && !this.resultado && contarMarcas(this.estado) > 0) {
      alertifyjs.confirm(
        'Cambiar de pantalla',
        'Lo que marcaste y no guardaste se va a perder. ¿Cambiar de pantalla?',
        () => this.reiniciar(),
        () => { }
      );
      return;
    }
    this.reiniciar();
  }

  reiniciar() {
    this.salirPantallaCompleta();
    this.rutaElegida = null;
    this.pidiendoValores = false;
    this.rutaAbierta = '';
    this.rutaDesviada = '';
    this.urlMarcador = null;
    this.estado = null;
    this.filaDetectada = null;
    this.quiereSubmoduloNuevo = false;
    this.creandoModulo = false;
    this.errorModulo = '';
    this.llamadasPantalla = [];
    this.reiniciarFormulario();
    this.form = null;
    this.errorForm = '';
    this.errorGuardar = '';
    this.resultado = null;
    this.marcasGuardadas = [];
    this.consulta = '';
    this.sugerencias = [];
    this.valores = {};
    this.limpiarRoles();
  }

  // ══════════════════════════════════════════
  //  PASO 2 · TARJETA «ESTA PANTALLA COMO SUBMÓDULO»
  // ══════════════════════════════════════════

  /** La pantalla (módulo) de la matriz elegida en la tarjeta. */
  get pantallaActual(): any {
    return this.estado ? this.pantallas.find((p: any) => p.id === this.estado.pantalla) || null : null;
  }

  /** Filas que hoy muestra ese módulo, para «Después de «X»». */
  get filasLugar(): any[] { return this.pantallaActual?.filas || []; }

  get gruposModulo(): any[] { return this.pantallaActual?.grupos || []; }

  /** Busca si la pantalla ya es una fila de la matriz y, si es así, la agrega a esa fila en vez de crear un submódulo. */
  detectarFila() {
    if (!this.estado || this.resultado || this.quiereSubmoduloNuevo || this.estado.filaExistente) return;
    // Sin `data.permissions` en la ruta, el mapa de IsProfileGuard dice su fila (invoice-dashboard → Compras Financiadas).
    const permisos = this.permisosActuales.length
      ? this.permisosActuales
      : codigosDelMapaDeRuta(this.estado.rutaPatron, IsProfileGuard.URL_MODULE_MAP, this.pantallas);
    const fila = buscarFilaDePantalla(this.pantallas, permisos, this.marcasGuardadas, this.estado.rutaPatron);
    this.filaDetectada = fila;
    if (fila) this.estado = conFilaExistente(this.estado, fila);
  }

  get textoFilaExistente(): string { return textoFilaExistente(this.filaDetectada); }

  get textoFilasElegida(): string { return textoFilasElegida(this.filaDetectada); }

  /** «Crear un submódulo nuevo en su lugar»: vuelve a la tarjeta de siempre. */
  crearSubmoduloNuevo() {
    if (!this.estado || this.resultado) return;
    this.quiereSubmoduloNuevo = true;
    this.estado = sinFilaExistente(this.estado, this.pantallas);
  }

  /** «Usar la fila que ya existe»: deshace lo anterior. */
  usarFilaExistente() {
    if (!this.estado || this.resultado || !this.filaDetectada) return;
    this.quiereSubmoduloNuevo = false;
    this.estado = conFilaExistente(this.estado, this.filaDetectada);
  }

  // ── Módulo nuevo ──

  /** El selector de módulo: «+ Nuevo módulo» abre el mini formulario en vez de cambiar de módulo. */
  elegirModulo(id: string) {
    if (!this.estado) return;
    if (id === MODULO_NUEVO) {
      this.creandoModulo = true;
      this.errorModulo = '';
      this.nuevoModulo = { nombre: '', despuesDe: '' };
      return;
    }
    this.creandoModulo = false;
    this.estado = { ...this.estado, pantalla: id };
    this.alCambiarModulo();
  }

  cancelarModulo() {
    this.creandoModulo = false;
    this.errorModulo = '';
  }

  async crearModulo() {
    if (this.guardandoModulo) return;
    this.errorModulo = problemaDeModulo(this.nuevoModulo.nombre, this.pantallas);
    if (this.errorModulo) return;
    this.guardandoModulo = true;
    try {
      const resp = await this.rbacService.crearPantalla(cuerpoModulo(this.nuevoModulo.nombre, this.nuevoModulo.despuesDe));
      const antes = this.pantallas.map((p: any) => p.id);
      await this.cargarPantallas();
      const creado = resp?.data?.id
        || (this.pantallas.find((p: any) => antes.indexOf(p.id) < 0) || {}).id;
      if (creado && this.estado) this.estado = { ...this.estado, pantalla: creado, despuesDe: '', grupo: '' };
      this.creandoModulo = false;
      alertifyjs.success('Módulo creado');
    } catch (error: any) {
      this.errorModulo = mensajeErrorModulo(error);
    }
    this.guardandoModulo = false;
  }

  /** Cambió el módulo: el lugar vuelve a «Al final del módulo» y el grupo se limpia. */
  alCambiarModulo() {
    if (!this.estado) return;
    this.estado = { ...this.estado, despuesDe: '', grupo: '' };
  }

  /** Cambió el lugar: el grupo sigue al de la fila elegida; en «Al final» se escoge aparte. */
  alCambiarLugar() {
    if (!this.estado) return;
    if (this.estado.despuesDe) this.estado = { ...this.estado, grupo: grupoDeFila(this.filasLugar, this.estado.despuesDe) };
  }

  // ══════════════════════════════════════════
  //  PASO 3 · LO QUE LA PANTALLA AVISA (iframe)
  // ══════════════════════════════════════════

  @HostListener('window:message', ['$event'])
  alRecibirMensaje(ev: MessageEvent) {
    if (ev.origin !== window.location.origin) return;
    const marco = this.marcador?.nativeElement;
    if (!marco || ev.source !== marco.contentWindow) return;
    const msg: any = ev.data;
    if (!msg || typeof msg.tipo !== 'string') return;
    if (msg.tipo === 'rbac-marcador:listo') {
      // Si la pantalla redirigió (guard, valor de ejemplo inválido), lo que se marque quedaría con una ruta equivocada.
      if (!rutaAbiertaCoincide(this.rutaAbierta, msg.ruta)) {
        this.rutaDesviada = typeof msg.ruta === 'string' && msg.ruta ? msg.ruta : 'desconocida';
        this.form = null;
        this.limpiarSeleccion();
        return;
      }
      if (!this.rutaDesviada) { this.enviarMarcas(); this.enviarModo(); }
    } else if (msg.tipo === 'rbac-marcador:salir') {
      this.salirPantallaCompleta();
    } else if (msg.tipo === 'rbac-marcador:toque') {
      this.abrirFormulario(msg);
    } else if (msg.tipo === 'rbac-marcador:llamadas') {
      this.llamadasPantalla = llamadasDelMensaje(msg);
      this.filtrarServidor();
    }
  }

  private mandar(msg: any) {
    const ventana = this.marcador?.nativeElement?.contentWindow;
    if (ventana) ventana.postMessage(msg, window.location.origin);
  }

  /** Le manda a la pantalla lo marcado para que dibuje las etiquetas (las de esta sesión y las ya guardadas). */
  enviarMarcas() {
    this.mandar({ tipo: 'rbac-marcador:marcas', marcas: marcasParaIframe(this.estado, this.marcasGuardadas), nombres: nombresDePermisos(this.pantallas) });
  }

  /** «Marcar» (cada clic selecciona) o «Usar la pantalla» (los clics pasan; nada se guarda). Por omisión, marcar. */
  modoMarcador = 'marcar';

  cambiarModo(modo: string) {
    this.modoMarcador = modo === 'usar' ? 'usar' : 'marcar';
    this.enviarModo();
  }

  private enviarModo() { this.mandar({ tipo: 'rbac-marcador:modo', modo: this.modoMarcador }); }

  private limpiarSeleccion() { this.mandar({ tipo: 'rbac-marcador:limpiar' }); }

  /** Deja el formulario de lo tocado como nuevo: sin buscadores abiertos ni «agrandar» a medias. */
  private reiniciarFormulario() {
    this.buscandoOtraOpcion = false;
    this.buscarEnTodas = false;
    this.busquedaServidor = '';
    this.busquedaPermiso = '';
    this.formAntesDeAgrandar = null;
    this.querraSeccion = false;
  }

  abrirFormulario(msg: any) {
    if (!this.estado || this.resultado || this.rutaDesviada) return;
    const venia = this.querraSeccion ? this.form : null;
    // «¿Querías marcar toda esa parte?»: lo que llega ahora es el contenedor y entra como sección.
    if (this.querraSeccion) msg = { ...msg, sugerencia: { ...(msg && msg.sugerencia), tipo: 'seccion' } };
    this.reiniciarFormulario();
    this.formAntesDeAgrandar = venia;
    this.form = formularioDeToque(msg, this.estado);
    this.errorForm = '';
    this.filtrarPermisos();
    this.cargarRutasServidor();
    this.filtrarServidor();
    setTimeout(() => this.formulario?.nativeElement?.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' }));
  }

  cambiarTipo(tipo: 'accion' | 'seccion') {
    if (!this.form || this.form.tipo === tipo) return;
    const pantalla = (this.estado?.nombre || '').trim();
    const nombre = (this.form.nombre || '').trim();
    this.form = { ...this.form, tipo, servidor: tipo === 'accion' ? this.form.servidor : null };
    // Si el nombre todavía es el propuesto, se re-propone con la forma del tipo nuevo.
    if (!this.form.existente) {
      const base = nombre.startsWith(pantalla + ' · ') ? nombre.slice(pantalla.length + 3) : nombre;
      this.form.nombre = tipo === 'seccion' ? `${pantalla} · ${base}` : base;
    }
    this.errorForm = '';
    this.filtrarServidor();
  }

  /** «Permiso: Nuevo | Uno que ya existe». */
  cambiarModoPermiso(modo: 'nuevo' | 'existente') {
    if (!this.form || this.form.tipo !== 'accion' || this.form.modoPermiso === modo) return;
    this.form = { ...this.form, modoPermiso: modo };
    if (modo === 'nuevo') this.form = { ...this.form, permisoExistente: '', permisoTexto: '' };
    // Con una casilla sugerida («Eliminar»), volver a «Los mismos que ya pueden» la vuelve a elegir.
    const sug = this.form.casillaSugerida;
    if (modo === 'existente' && sug && !this.form.permisoExistente) {
      this.form = { ...this.form, permisoExistente: sug.code, permisoTexto: sug.nombre, nombre: sug.nombre };
    }
    this.buscandoOtraOpcion = false;
    this.errorForm = '';
  }

  /** Filtra todas las casillas de la matriz (Módulo › Fila › Casilla) con lo escrito en el buscador. */
  filtrarPermisos() {
    const r = buscarCasillas(casillasDeMatriz(this.pantallas), this.busquedaPermiso);
    this.resultadosPermiso = r.lista;
    this.totalPermiso = r.total;
  }

  elegirPermiso(c: any) {
    this.form = { ...this.form, permisoExistente: c.code, permisoTexto: c.texto, nombre: c.nombre };
    this.buscandoOtraOpcion = false;
    this.errorForm = '';
    this.filtrarServidor();
  }

  esPermisoElegido(c: any): boolean { return !!this.form && this.form.permisoExistente === c.code; }

  /** «¿Querías marcar toda esa parte de la pantalla?»: sube al contenedor y pasa a sección. */
  agrandar() {
    this.querraSeccion = true;
    this.mandar({ tipo: 'rbac-marcador:subir' });
  }

  /** Varios elementos iguales: «solo este» o «todos». */
  elegirAlcance(alcance: 'solo' | 'todos') {
    if (this.form) this.form = conAlcance(this.form, alcance);
  }

  /** «Usar ese mismo»: el elemento ya está protegido por el código; se reutiliza su permiso en vez de crear otro. */
  usarElMismo(y: any) {
    if (!this.form || !y) return;
    if (this.form.tipo !== 'accion') this.cambiarTipo('accion');
    this.form = { ...this.form, modoPermiso: 'existente' };
    this.elegirPermiso({ code: y.codigo, texto: y.texto, nombre: ultimoTramo(y.texto) });
  }

  get textoYaTiene(): string { return this.form ? textoYaTiene(this.form) : ''; }

  /** «Es solo un botón»: vuelve a lo que se había tocado (o, sin eso, el mismo elemento como acción). */
  soloUnBoton() {
    if (!this.form) return;
    this.querraSeccion = false;
    if (this.formAntesDeAgrandar) {
      this.form = this.formAntesDeAgrandar;
      this.formAntesDeAgrandar = null;
      this.errorForm = '';
      this.filtrarServidor();
    } else {
      this.cambiarTipo('accion');
    }
  }

  marcar() {
    if (!this.form || this.rutaDesviada) return;
    this.errorForm = problemaDeMarca(this.estado, this.form);
    if (this.errorForm) return;
    this.estado = aplicarMarca(this.estado, this.form);
    this.form = null;
    this.reiniciarFormulario();
    this.limpiarSeleccion();
    this.enviarMarcas();
  }

  cancelar() {
    this.form = null;
    this.reiniciarFormulario();
    this.errorForm = '';
    this.limpiarSeleccion();
  }

  /** «Quitar marca» desde el formulario de un elemento ya marcado. */
  quitarDelFormulario() {
    if (!this.form?.id) return;
    this.quitarPendiente(this.form.id);
    this.form = null;
    this.limpiarSeleccion();
  }

  /** Quita una acción o sección que todavía no se guardó (la ×, o «Quitar marca»). */
  quitarPendiente(id: string) {
    this.estado = quitarMarca(this.estado, id);
    this.enviarMarcas();
  }

  // ── «Qué cuida también en el servidor» ──

  async cargarRutasServidor() {
    if (this.servidorPedido) return;
    this.servidorPedido = true;
    this.cargandoServidor = true;
    this.errorServidor = false;
    try {
      const resp = await this.rbacService.getRutasServidor();
      this.rutasServidor = resp?.data || [];
    } catch (error) {
      console.error('[Agregar permisos] No se pudieron cargar las rutas del servidor:', error);
      this.servidorPedido = false; // permite reintentar al abrir otro formulario
      this.errorServidor = true;
    }
    this.cargandoServidor = false;
    this.filtrarServidor();
  }

  filtrarServidor() {
    const metodo = this.form?.tipo === 'accion' ? metodoSugerido(this.form.nombre) : '';
    const r = filtrarRutasServidor(this.rutasServidor, this.busquedaServidor, metodo);
    this.resultadosServidor = r.lista;
    this.totalServidor = r.total;
    const sug = sugerenciasServidor(this.rutasServidor, this.llamadasPantalla, this.estado?.rutaPatron || '', metodo);
    this.usadasServidor = sug.usadas;
    this.parecidasServidor = sug.parecidas;
  }

  /** «Buscar en todas»: el buscador completo de las llamadas del servidor. */
  abrirBuscadorServidor() {
    this.buscarEnTodas = true;
    this.filtrarServidor();
  }

  elegirServidor(r: any) {
    this.form = { ...this.form, servidor: { metodo: r.metodo, ruta: r.ruta } };
  }

  quitarServidor() {
    this.form = { ...this.form, servidor: null };
  }

  esServidorElegido(r: any): boolean {
    const s = this.form?.servidor;
    return !!s && s.metodo === r.metodo && s.ruta === r.ruta;
  }

  etiquetaMetodo(metodo: string): string { return etiquetaMetodo(metodo); }

  textoLlanoMetodo(metodo: string): string { return textoLlanoMetodo(metodo); }

  // ── Textos del panel (lenguaje llano) ──

  get queTocaste(): string { return this.form ? queTocaste(this.form) : ''; }

  get notaCoincidencias(): string { return this.form ? notaCoincidencias(this.form) : ''; }

  /** «Se agrega a la Matriz de Permisos en Módulo › Pantalla…». Una sección es una fila aparte con su propio nombre. */
  get textoDondeSeAgrega(): string {
    if (!this.form) return '';
    return dondeSeAgrega(this.pantallaActual?.nombre, this.form.tipo === 'accion' ? this.estado?.nombre : this.form.nombre);
  }

  /** Nombre de la opción elegida en «Los mismos que ya pueden …». */
  get nombreOpcionElegida(): string { return this.form ? ultimoTramo(this.form.permisoTexto || this.form.nombre) : ''; }

  detalleMarca(marca: any, esSeccion: boolean): string { return detalleDeMarca(marca, esSeccion); }

  get resumenAgregar(): string { return resumenAgregar(this.estado, this.pantallaActual?.nombre); }

  get resumenQuienVera(): string { return resumenQuienVera(this.darARoles, this.rolesElegidos, this.bloqueRoles.lista); }

  // ══════════════════════════════════════════
  //  PASO 4 · REVISAR Y GUARDAR
  // ══════════════════════════════════════════

  get totalPermisos(): number { return this.estado ? contarPermisos(this.estado) : 0; }

  /** Lo que falta o choca antes de guardar. Con la pantalla desviada va primero: mientras esté, «Guardar» queda bloqueado. */
  get problemas(): string[] {
    const p = problemasDeEstado(this.estado, this.filasLugar);
    return this.rutaDesviada ? [textoRutaDesviada(this.rutaDesviada)].concat(p) : p;
  }

  get textoRutaDesviada(): string { return textoRutaDesviada(this.rutaDesviada); }

  get lugarTexto(): string {
    return this.estado?.despuesDe ? `Después de «${this.estado.despuesDe}»` : 'Al final del módulo';
  }

  // ── Dar los permisos a los roles que hoy ya ven la pantalla ──

  private limpiarRoles() {
    this.pedidoRoles++;
    this.permisosActuales = [];
    this.roles = [];
    this.cargandoRoles = false;
    this.errorRoles = '';
    this.darARoles = true;
    this.rolesElegidos = [];
    this.rolesExtra = [];
    this.recalcularBloqueRoles();
  }

  /** Pide qué roles ven hoy la pantalla: los permisos salen de su ruta en el router (vacío si no exige ninguno). */
  async cargarRoles(ruta?: string) {
    const patron = ruta || this.rutaElegida?.ruta || '';
    if (!patron) return;
    this.limpiarRoles();
    const pedido = this.pedidoRoles;
    this.permisosActuales = permisosDeRuta(this.router.config, patron);
    this.cargandoRoles = true;
    try {
      const resp = await this.rbacService.getRolesQueVen(this.permisosActuales);
      if (pedido !== this.pedidoRoles) return;
      this.roles = resp?.data || [];
      this.rolesElegidos = rolesPreseleccionados(this.roles);
    } catch (error: any) {
      if (pedido !== this.pedidoRoles) return;
      console.error('[Agregar permisos] No se pudieron cargar los roles que ven la pantalla:', error);
      this.errorRoles = error?.error?.msg || 'No se pudo ver qué roles usan hoy esta pantalla.';
    }
    this.cargandoRoles = false;
    this.recalcularBloqueRoles();
  }

  private recalcularBloqueRoles() {
    this.bloqueRoles = repartirRoles(this.roles, this.rolesExtra);
  }

  get hayRoles(): boolean { return this.bloqueRoles.lista.length + this.bloqueRoles.yaTienenTodo.length > 0; }

  get textoYaTienenTodo(): string { return textoYaTienenTodo(this.bloqueRoles.yaTienenTodo); }

  get resumenRoles(): string { return resumenRolesMarcados(this.rolesElegidos, this.bloqueRoles.lista); }

  get mensajeAsignados(): string { return mensajeAsignados(this.resultado); }

  /** Roles que recibirán los permisos al guardar (o `null`: no se manda `asignarARoles`). */
  get rolesPorAsignar(): string[] | null {
    // Los roles reciben solo permisos NUEVOS: si no se crea ninguno no se manda `asignarARoles`.
    return this.totalPermisos === 0 ? null : rolesAAsignar(this.darARoles, this.rolesElegidos, this.roles);
  }

  estaElegido(codigo: string): boolean { return this.rolesElegidos.indexOf(codigo) >= 0; }

  tocarRol(codigo: string) {
    if (this.resultado) return;
    this.rolesElegidos = alternarRol(this.rolesElegidos, codigo);
  }

  /** «Agregar otro rol»: pasa a la lista, ya marcado. */
  agregarOtroRol(codigo: string) {
    if (!codigo || this.resultado || this.rolesExtra.indexOf(codigo) >= 0) return;
    this.rolesExtra = this.rolesExtra.concat([codigo]);
    this.rolesElegidos = this.rolesElegidos.indexOf(codigo) >= 0 ? this.rolesElegidos : this.rolesElegidos.concat([codigo]);
    this.recalcularBloqueRoles();
  }

  trackPorCodigo(_indice: number, rol: any): string { return rol.code; }

  async guardar() {
    if (!this.estado || this.guardando || this.cargandoRoles || this.resultado || this.problemas.length) return;
    this.guardando = true;
    this.errorGuardar = '';
    try {
      const resp = await this.rbacService.agregarPermisos(armarCuerpo(this.estado, this.rolesPorAsignar));
      this.resultado = resp?.data || {};
      this.form = null;
      const aRoles = mensajeAsignados(this.resultado);
      alertifyjs.success('Permisos agregados a la matriz' + (aRoles ? '. ' + aRoles : ''));
      this.guardado.emit(this.resultado);
      this.vigilante.recargarMarcas(); // la sesión de quien guarda también debe ver las marcas nuevas, sin volver a entrar
      // Lo recién guardado ya es una marca de la pantalla y una fila de la matriz.
      await Promise.all([this.cargarMarcasGuardadas(), this.cargarPantallas(), this.cargarProtecciones()]);
    } catch (error: any) {
      if (error?.status === 409) {
        this.errorGuardar = mensajeRepetidos(this.estado, codigosRepetidos(error));
      } else {
        this.errorGuardar = error?.error?.msg || 'No se pudo guardar. Revisa la conexión e intenta de nuevo.';
      }
    }
    this.guardando = false;
  }

  /** Agregar otra pantalla después de guardar (o descartar y empezar de nuevo). */
  agregarOtra() { this.reiniciar(); }

  // ── Lo que ya estaba protegido en esta pantalla ──

  async cargarMarcasGuardadas() {
    if (!this.estado) return;
    try {
      const resp = await this.rbacService.getMarcas();
      this.marcasGuardadas = marcasDeRuta(resp?.data || [], this.estado.rutaPatron);
    } catch (error) {
      console.error('[Agregar permisos] No se pudieron cargar las marcas guardadas:', error);
      this.marcasGuardadas = [];
    }
    this.detectarFila();
    this.enviarMarcas();
  }

  tipoMarcaTexto(tipo: string): string {
    return tipo === 'accion' ? 'Acción' : tipo === 'seccion' ? 'Sección' : 'Pantalla completa';
  }

  quitarGuardada(m: any) {
    alertifyjs.confirm(
      'Quitar marca',
      'La marca deja de esconder ese elemento. El permiso sigue en la matriz. ¿Quitarla?',
      async () => {
        try {
          await this.rbacService.quitarMarca(m._id);
          alertifyjs.success('Marca quitada');
          await this.cargarMarcasGuardadas();
        } catch (error: any) {
          alertifyjs.error(error?.error?.msg || 'No se pudo quitar la marca');
        }
      },
      () => { }
    );
  }

  // ══════════════════════════════════════════
  //  LO QUE TAMBIÉN CUIDA EL SERVIDOR
  // ══════════════════════════════════════════

  /** Todas las protecciones (no solo las de la pantalla abierta). Se carga al abrir la pestaña y tras cada «Guardar». */
  async cargarProtecciones() {
    this.cargandoProtecciones = true;
    this.errorProtecciones = '';
    try {
      const resp = await this.rbacService.getProtecciones();
      this.protecciones = resp?.data || [];
    } catch (error: any) {
      console.error('[Agregar permisos] No se pudieron cargar las protecciones del servidor:', error);
      this.errorProtecciones = error?.error?.msg || 'No se pudo cargar la lista de llamadas del servidor. Revisa la conexión e intenta de nuevo.';
    }
    this.cargandoProtecciones = false;
    // Si la fila que esperaba confirmación ya no está apagada (o ya no existe), se descarta.
    const espera = this.proteccionPorEncender;
    if (espera && !this.protecciones.some((p: any) => String(p._id) === espera.id && p.activo !== true)) {
      this.proteccionPorEncender = null;
    }
    this.filtrarProtecciones();
  }

  /** Recalcula las filas visibles (filtro de texto y nombres de los permisos). */
  filtrarProtecciones() {
    this.proteccionesVisibles = filasProtecciones(this.protecciones, this.pantallas, this.busquedaProtecciones);
  }

  alEscribirFiltroProtecciones(texto: string) {
    this.busquedaProtecciones = texto;
    this.proteccionPorEncender = null;
    this.filtrarProtecciones();
  }

  get hayFiltroProtecciones(): boolean { return hayFiltroProtecciones(this.protecciones); }

  get resumenProtecciones(): string { return resumenProtecciones(this.protecciones); }

  textoEncender(nombre: string): string { return textoEncender(nombre); }

  trackPorId(_indice: number, fila: any): string { return fila.id; }

  /** El interruptor: apagar se hace al instante; encender primero pide confirmación dentro de la fila. */
  tocarInterruptor(fila: any) {
    if (this.cambiandoProteccion) return;
    this.errorCambio = '';
    if (fila.activo) {
      this.cambiarProteccion(fila, false);
    } else {
      this.proteccionPorEncender = fila;
    }
  }

  cancelarEncender() { this.proteccionPorEncender = null; }

  confirmarEncender() {
    const fila = this.proteccionPorEncender;
    if (fila && !this.cambiandoProteccion) this.cambiarProteccion(fila, true);
  }

  private async cambiarProteccion(fila: any, activo: boolean) {
    this.cambiandoProteccion = fila.id;
    this.errorCambio = '';
    try {
      await this.rbacService.cambiarProteccion(fila.id, activo);
      alertifyjs.success(activo ? 'Protección encendida' : 'Protección apagada');
    } catch (error: any) {
      this.errorCambio = mensajeErrorProteccion(error, activo);
    }
    this.proteccionPorEncender = null;
    this.cambiandoProteccion = '';
    // Siempre se recarga, también tras un error, para ver cómo quedó de verdad.
    await this.cargarProtecciones();
  }
}
